module.exports = __webpack_public_path__ + "img/vlad.09ae3bbf.jpg";